import { render, staticRenderFns } from "./FaqDialog.vue?vue&type=template&id=b07702d0&scoped=true&"
import script from "./FaqDialog.vue?vue&type=script&lang=js&"
export * from "./FaqDialog.vue?vue&type=script&lang=js&"
import style0 from "./FaqDialog.vue?vue&type=style&index=0&id=b07702d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07702d0",
  null
  
)

export default component.exports